<template>
  <a-modal :title="$t('乐谱审核')" :visible="visible" :confirm-loading="submitLoading" @ok="submitForm" @cancel="onClose">
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('乐谱标题')">
        <span>{{ current.title }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('上传用户')">
        <span>{{ current.userName || '-' }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('审核结果')" prop="auditStatus">
        <a-radio-group v-model="form.auditStatus">
          <a-radio :value="1310">{{ $t('通过') }}</a-radio>
          <a-radio :value="1320">{{ $t('驳回') }}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.auditStatus === 1320" :label="$t('驳回原因')" prop="rejectReason">
        <a-input v-model="form.rejectReason" :maxLength="255" :placeholder="$t('请输入')+$t('驳回原因')" type="textarea" allow-clear />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { auditSheet } from '@/api/sheet/sheet'

export default {
  name: 'AuditForm',
  data () {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      visible: false,
      current: {},
      form: {
        id: null,
        auditStatus: 1310,
        rejectReason: null
      },
      rules: {
        auditStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        rejectReason: [{ required: true, message: '驳回时必须填写驳回原因', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open (record) {
      this.current = record
      this.form = {
        id: record.id,
        auditStatus: 1310,
        rejectReason: null
      }
      this.visible = true
    },
    onClose () {
      this.visible = false
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          auditSheet(this.form).then(response => {
            this.$message.success(this.$t('审核成功'), 3)
            this.visible = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
